import React from 'react';
import { useNavigate } from 'react-router-dom';
import { House } from '@phosphor-icons/react';

export const HomeownerActivitySummary = ({ quoteStats, activeProjects, unreadCount, walletBalance }) => {
  const navigate = useNavigate();
  return (
    <div className="bg-emerald-50 dark:bg-emerald-900/10 border-2 border-emerald-300 dark:border-emerald-800 rounded-xl p-4 mb-6" data-testid="homeowner-activity-summary">
      <h3 className="text-sm font-black uppercase text-emerald-800 dark:text-emerald-400 mb-3 flex items-center gap-2">
        <House size={18} weight="bold" /> Homeowner Activity
      </h3>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        <div className="bg-white dark:bg-neutral-800 border border-amber-300 dark:border-amber-700 rounded-lg p-3 text-center">
          <p className="text-xl font-black text-amber-600">{quoteStats.pending || 0}</p>
          <p className="text-[10px] font-bold uppercase text-neutral-500">Pending Quotes</p>
        </div>
        <div className="bg-white dark:bg-neutral-800 border border-blue-300 dark:border-blue-700 rounded-lg p-3 text-center">
          <p className="text-xl font-black text-blue-600">{quoteStats.site_visit || 0}</p>
          <p className="text-[10px] font-bold uppercase text-neutral-500">Site Visits</p>
        </div>
        <div className="bg-white dark:bg-neutral-800 border border-emerald-300 dark:border-emerald-700 rounded-lg p-3 text-center">
          <p className="text-xl font-black text-emerald-600">{activeProjects.length}</p>
          <p className="text-[10px] font-bold uppercase text-neutral-500">Active Projects</p>
        </div>
        <div className="bg-white dark:bg-neutral-800 border border-[#3B82F6]/40 rounded-lg p-3 text-center">
          <p className="text-xl font-black text-[#475569]">{unreadCount}</p>
          <p className="text-[10px] font-bold uppercase text-neutral-500">Unread Messages</p>
        </div>
        <div className="bg-white dark:bg-neutral-800 border border-emerald-300 dark:border-emerald-700 rounded-lg p-3 text-center cursor-pointer hover:bg-emerald-50 dark:hover:bg-emerald-900/20 transition-colors" onClick={() => navigate('/wallet')} data-testid="wallet-balance-card">
          <p className="text-xl font-black text-emerald-600">${walletBalance.toLocaleString()}</p>
          <p className="text-[10px] font-bold uppercase text-neutral-500">Wallet Balance</p>
        </div>
      </div>
    </div>
  );
};
